"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "ursa-icon__74a62640a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.833 4.936a.7.7 0 0 1 .7.7v2.177a.3.3 0 0 0 .144.256l1.673 1.02a.7.7 0 1 1-.729 1.196l-1.673-1.02a1.7 1.7 0 0 1-.815-1.452V5.636a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.833 4.936a.7.7 0 0 1 .7.7v2.177a.3.3 0 0 0 .144.256l1.673 1.02a.7.7 0 1 1-.729 1.196l-1.673-1.02a1.7 1.7 0 0 1-.815-1.452V5.636a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m8.677 8.069.52-.854zm1.673 1.02.52-.854zm-.729 1.196-.52.854zm-1.673-1.02.52-.854zm1.585-3.63a1.7 1.7 0 0 0-1.7-1.7v2a.3.3 0 0 1-.3-.3zm0 2.178V5.636h-2v2.177zm-.336-.598a.7.7 0 0 1 .336.598h-2c0 .453.236.874.623 1.11zm1.674 1.02-1.674-1.02-1.04 1.708 1.673 1.02zm.566 2.337a1.7 1.7 0 0 0-.566-2.337L9.83 9.943a.3.3 0 0 1-.1-.412zm-2.336.567a1.7 1.7 0 0 0 2.336-.567L9.73 9.53a.3.3 0 0 1 .412-.1zm-1.674-1.02 1.674 1.02 1.041-1.708-1.673-1.02zM6.133 7.812a2.7 2.7 0 0 0 1.294 2.305L8.47 8.411a.7.7 0 0 1-.336-.598zm0-2.177v2.177h2V5.636zm1.7-1.7a1.7 1.7 0 0 0-1.7 1.7h2a.3.3 0 0 1-.3.3zM4.4 8A3.6 3.6 0 0 1 8 4.4v-2A5.6 5.6 0 0 0 2.4 8zM8 11.6A3.6 3.6 0 0 1 4.4 8h-2A5.6 5.6 0 0 0 8 13.6zM11.6 8A3.6 3.6 0 0 1 8 11.6v2A5.6 5.6 0 0 0 13.6 8zM8 4.4A3.6 3.6 0 0 1 11.6 8h2A5.6 5.6 0 0 0 8 2.4zM8 1a7 7 0 0 0-7 7h2a5 5 0 0 1 5-5zm7 7a7 7 0 0 0-7-7v2a5 5 0 0 1 5 5zm-7 7a7 7 0 0 0 7-7h-2a5 5 0 0 1-5 5zM1 8a7 7 0 0 0 7 7v-2a5 5 0 0 1-5-5z",
  mask: "url(#ursa-icon__74a62640a)"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ClockIcon16.js.map